import React from 'react'
import { InputPeripheral } from "utils/PeripheralManager"
import { sleep } from 'component_utils/utils'

const MaintenanceComponent = ({device}: {device: TestCartoncube}) => {
  return (<></>)
}

// _be_peripheral_input_{"usage":"cartoncube","driverName":"TEST","deviceName":"test","settings":{"t": 500}}
class TestCartoncube implements InputPeripheral<TestCartoncube> {
  _isConnected: boolean;
  _config: any;

  setConfig(config: any) {
    this._config = config
  }
  getDriverName = () => 'TEST'

  connect = async (data: any) => {
    this._isConnected = true;
  }
  disconnect = async () => {
    this._isConnected = false;
  }

  isConnected = async () => {
    return Promise.resolve(this._isConnected)
  }

  getValue = async () => { 
    await sleep(this._config.t || 1000)
    return this._config.v || JSON.stringify({
      __isCardOnCubeResponse__: true,
      width: 10,
      height: 12,
      depth: 14,
      weight: 1.4
    })
  }

  getMaintenanceComponent = () => MaintenanceComponent
}

(TestCartoncube as any)._do_not_register_device = true

export default TestCartoncube